import React, { useEffect } from "react";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useBreadcrumbs } from "../../../../context/breadcrumbs";
import { config } from "@triare/auth-redux";
import { SurveyBuilder } from "../SurveyBuilder";
import SinglePageContainer from "../../../Common/SinglePageContainer";
import { Button } from "antd";

const { displayName } = config;

export default function SurveyCreateContent(): React.ReactNode | null {
  const { t, i18n } = useTranslation();
  const { setBreadcrumbs } = useBreadcrumbs();

  // Three levels on a screen one step in: home, the section it
  // belongs to as a link back, and the action being performed.
  useEffect(() => {
    setBreadcrumbs([
      { title: <HomeOutlined />, href: "/" },
      { title: t("routes.survey"), href: "/survey" },
      { title: t("common.create") },
    ]);
  }, [i18n.language, t]);

  useEffect(() => {
    document.title = `${displayName}: Survey Create`;
  }, []);

  return (
    <SinglePageContainer
      title="Survey Create"
      extra={
        <>
          <Button>Save as draft</Button>
          <Button type="primary">Save</Button>
        </>
      }
    >
      <SurveyBuilder />
    </SinglePageContainer>
  );
}
